<template>
  <BackButton @click="goBack" />
  <div class="home">
    <div class="loading" v-if="loading">
      <p>{{ $t("loading") }}</p>
    </div>

    <div class="competition" v-else-if="!loading && competition">
      <div class="banner">
        <div class="banner_info">
          <p class="banner_info_header">{{ competition.title }}</p>
          <div class="banner_info_timer" v-if="competition.status !== 'ended'">
            <p>{{ $t("competitionUntilTheEnd") }}</p>
            <span>{{ timeRemaining }}</span>
          </div>
          <div class="banner_info_timer completed" v-else>
            <p>{{ $t("competitionEnd") }}</p>
          </div>
        </div>
        <img :src="competition.banner_url" />
      </div>

      <p class="competition_title" v-if="competition.status !== 'ended'">{{ $t("competitionTerms") }}</p>
      <div class="terms_list" v-if="competition.status !== 'ended'">
        <div class="term_block" v-for="condition in competition.conditions" :key="condition.id">
          <div class="term_block_info">
            <p>{{ condition.description }}</p>
            <p class="completed" v-if="condition.is_completed">{{ $t("competitionCompleted") }}</p>
            <p class="not-completed" v-else>{{ $t("competitionNotCompleted") }}</p>
          </div>
          <div class="term_block_status">
            <ProgressCircle :progress="condition.progress_percent" :completed="condition.is_completed" />
          </div>
        </div>
      </div>

      <p class="competition_title">{{ $t("competitionPrizes") }}</p>
      <div class="terms_list">
        <div class="term_block" v-for="prize in competition.prizes" :key="prize.id">
          <div class="term_block_info">
            <p v-if="prize.position_from === prize.position_to">{{ prize.position_from }} {{ $t("place") }}</p>
            <p v-else>{{ prize.position_from }}-{{ prize.position_to }} {{ $t("places") }}</p>
            <p class="prize_description" v-if="prize.description">{{ prize.description }}</p>
          </div>
          <div class="term_block_status prize">
            <p>{{ prize.amount }} {{ competition.prize_currency }}</p>
          </div>
        </div>
      </div>

      <button v-if="competition.status === 'active' && !competition.is_registered" class="take_part" @click="registerForCompetition" :disabled="registering">
        {{ registering ? $t("registering") : $t("competitionParticipate") }}
      </button>

      <button v-if="competition.status === 'active' && competition.is_registered" class="take_part stop">
        {{ $t("competitionAlreadyParticipate") }}
      </button>

      <button v-if="competition.status === 'upcoming'" class="take_part inactive">
        {{ $t("competitionUpcoming") }}
      </button>

      <div class="participants">
        <div class="participants_head">
          <p class="competition_title" style="margin-top: 0">
            {{ competition.status !== "ended" ? $t("competitionMembers") : $t("competitionWinners") }}
          </p>
          <p class="participants_count">
            {{ competition.status == "ended" ? competition.winners.length : competition.participants_count }}
            {{ getParticipantsText(competition.participants_count, competition.status !== "ended") }}
          </p>
        </div>
        <div class="participants_list">
          <div class="participant_line" v-for="(participant, index) in competition.status == 'ended' ? competition.winners : participants" :key="index">
            <div class="participant_line_left">
              <p class="participant_number">{{ index + 1 }}</p>
              <div class="participant_avatar" :style="getAvatarStyle(participant.user_name)">
                {{ getAvatarInitials(participant.user_name) }}
              </div>
              <p class="participant_name">{{ participant.user_name }}</p>
            </div>
            <hr class="cross" v-if="index + 1 !== participants.length" />
            <div class="participant_line_right">
              <p></p>
              <!-- <p v-if="competition.status !== 'ended'">{{ $t("competitionTrading") }} ${{ participant.volume }}</p> -->
              <p class="win_money" v-if="competition.status === 'ended'">+${{ participant.prize_amount }} {{ competition.prize_currency }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="!loading && !competition" class="error">
      <p>{{ $t("competitionNotFound") }}</p>
    </div>
  </div>
  <Transition name="fade">
    <NotifyComponent :timely="false" :duration="3" :notify="notifyText" v-if="isShowNotify" @closeNotify="isShowNotify = false" />
  </Transition>
</template>

<script>
import { BackButton } from "vue-tg";
import axios from "axios";
import { UserManager } from "@/utils/userManager";
import { translateApiError } from "@/utils/apiErrors";
import ProgressCircle from "./ProgressCircle.vue";
import NotifyComponent from "./NotifyComponent.vue";

export default {
  name: "CompetitionComponent",
  data() {
    return {
      competition: null,
      loading: true,
      registering: false,
      error: null,
      timeRemaining: "",
      timer: null,
      userId: null,
      botId: null,
      notifyText: "",
      isShowNotify: false,
      participants: [
        { name: "pashka", volume: "1,248", prize: "500" },
        { name: "alex_trader", volume: "2,156", prize: "300" },
        { name: "crypto_king", volume: "1,987", prize: "200" },
        { name: "moon_boy", volume: "1,654", prize: "100" },
        { name: "hodler_2024", volume: "1,432", prize: "50" },
      ],
    };
  },
  async mounted() {
    const userContext = UserManager.getFullUserContext();
    this.userId = userContext.user.id;
    this.botId = userContext.botId;
    this.$store.commit("setBotId", this.botId);
    this.$store.commit("setTgUserData", userContext.user);

    await this.loadCompetition();
    this.startTimer();
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async loadCompetition() {
      try {
        this.loading = true;
        const competitionId = this.$route.params.id;

        const response = await axios.get(`${window.location.origin}/rcompetitions/${competitionId}`, {
          params: {
            user_id: this.userId,
            bot_id: this.botId,
          },
        });

        if (response.data.success) {
          this.competition = response.data.competition;
          this.participants = this.competition.participants.slice(0, 20);
          console.log(this.competition);
        } else {
          this.error = response.data.message || this.$t("competitionNotFound");
        }
      } catch (error) {
        console.error("Ошибка загрузки конкурса:", error);
        this.error = this.$t("network-error");
      } finally {
        this.loading = false;
      }
    },

    async registerForCompetition() {
      if (this.registering) return;

      try {
        this.registering = true;

        const response = await axios.post(`${window.location.origin}/rcompetitions/${this.competition.id}/register`, {
          user_id: this.userId,
          bot_id: this.botId,
        });

        if (response.data.success) {
          this.competition.is_registered = true;
          this.competition.participants_count += 1;
          // Показываем уведомление об успешной регистрации
          this.showNotify(translateApiError(this.$t.bind(this), response.data.message));
        } else {
          console.log(response);
          this.showNotify(translateApiError(this.$t.bind(this), response.data.message));
        }
      } catch (error) {
        console.error("Ошибка регистрации:", error);
        // this.$toast.error(this.$t("registration-error"))
      } finally {
        this.registering = false;
      }
    },
    showNotify(text) {
      this.notifyText = text;
      this.isShowNotify = true;
    },
    startTimer() {
      if (!this.competition || this.competition.status === "ended") return;

      this.timer = setInterval(() => {
        this.updateTimeRemaining();
      }, 1000);

      this.updateTimeRemaining();
    },

    updateTimeRemaining() {
      if (!this.competition) return;

      const now = new Date();
      const endDate = new Date(this.competition.end_date);
      const diff = endDate - now;

      if (diff <= 0) {
        this.timeRemaining = this.$t("competitionEnd");
        if (this.timer) {
          clearInterval(this.timer);
        }
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (days > 0) {
        this.timeRemaining = `${days}${this.$t("timeDays")} ${hours}${this.$t("timeHours")} ${minutes}${this.$t("timeMinutes")}`;
      } else if (hours > 0) {
        this.timeRemaining = `${hours}${this.$t("timeHours")} ${minutes}${this.$t("timeMinutes")} ${seconds}${this.$t("timeSeconds")}`;
      } else {
        this.timeRemaining = `${minutes}${this.$t("timeMinutes")} ${seconds}${this.$t("timeSeconds")}`;
      }
    },

    getParticipantsText(count, isActive) {
      const baseKey = isActive ? "competitionMembers" : "competitionWinners";

      if (count === 1) {
        return this.$t(baseKey + "One");
      } else {
        return this.$t(baseKey + "Many");
      }
    },
    getAvatarInitials(name) {
      const safeName = String(name || "").trim();
      if (!safeName) return "??";

      const prepared = safeName
        .replace(/([a-zа-яё])([A-ZА-ЯЁ])/g, "$1 $2")
        .replace(/[_\-.]+/g, " ")
        .replace(/\d+/g, " ")
        .trim();

      const words = prepared.match(/[A-Za-zА-Яа-яЁё]+/g) || [];

      if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
      }

      if (words.length === 1) {
        return words[0].slice(0, 2).toUpperCase();
      }

      return safeName.slice(0, 2).toUpperCase();
    },
    getAvatarStyle(name) {
      const gradients = [
        ["#54A3FF", "#006EFD"],
        ["#5EE7DF", "#66A6FF"],
        ["#F6D365", "#FDA085"],
        ["#F093FB", "#F5576C"],
        ["#43E97B", "#38F9D7"],
        ["#FA709A", "#FEE140"],
        ["#30CFD0", "#330867"],
        ["#A18CD1", "#FBC2EB"],
      ];

      const safeName = String(name || "");
      let hash = 0;
      for (let i = 0; i < safeName.length; i += 1) {
        hash = (hash << 5) - hash + safeName.charCodeAt(i);
        hash |= 0;
      }

      const index = Math.abs(hash) % gradients.length;
      const [start, end] = gradients[index];

      return {
        background: `linear-gradient(135deg, ${start}, ${end})`,
      };
    },

    goBack() {
      window.history.back();
    },
  },
  components: { BackButton, ProgressCircle, NotifyComponent },
};
</script>

<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
  overflow-y: auto;
}

.loading,
.error {
  text-align: center;
  padding: 2rem;
}

.competition {
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: left;
}

.competition_title {
  margin-top: 15px;
  font-size: 18px;
  font-family: "SF Pro Text Bold";
}

.banner {
  border-radius: 10px;
  overflow: hidden;
  height: 9em;
  position: relative;
}

.banner_info {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  padding: 5%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
}

.banner_info_header {
  color: #ffffff;
  font-size: 20px;
  font-family: "SF Pro Text Bold";
  text-align: left;
  line-height: 22px;
  max-width: 70%;
}

.banner_info_timer {
  text-align: left;
  display: flex;
  gap: 10px;
  font-size: 14px;
  background-color: #2f313a;
  width: fit-content;
  border-radius: 500px;
  padding: 7px 15px;
}

.banner_info_timer.completed {
  background-color: white;
}

.banner_info_timer.completed p {
  color: #21252b;
}

.banner_info_timer p {
  color: #6d6e75;
}

.banner_info_timer span {
  color: #8a8b8f;
}

.banner img {
  height: 9em;
  width: 100%;
  object-fit: cover;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 10px;
}

.terms_list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
}

.term_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--second-color);
  border-radius: 10px;
  padding: 7px 15px;
}

.term_block_info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.term_block_info p:nth-child(1) {
  font-size: 17px;
}

.term_block_info p:nth-child(2) {
  font-size: 15px;
  font-family: "SF Pro Text Bold";
}

.completed {
  color: #007aff;
}

.not-completed {
  color: #ff9500;
}

.prize_description {
  font-size: 13px;
  color: #737373;
}

.term_block_status.prize {
  background-color: var(--background-color);
  padding: 5px 13px;
  border-radius: 500px;
}

.take_part {
  margin-top: 15px;
  background-color: #007aff;
  border-radius: 10px;
  border: none;
  color: white;
  font-size: 16px;
  font-family: "SF Pro Text Bold";
  padding: 10px;
  position: relative;
  cursor: pointer;
}

.take_part:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.take_part.inactive {
  opacity: 0.2;
}

.take_part.stop {
  background-color: var(--competition-stop);
  color: #959596;
}

.participants {
  margin-top: 15px;
}

.participants_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.participants_count {
  color: #79787b;
  font-weight: 16px;
}

.participants_list {
  display: flex;
  flex-direction: column;
  background-color: var(--second-color);
  border-radius: 10px;
  padding: 10px;
  gap: 15px;
  margin-top: 10px;
}

.participant_line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.participant_line_left {
  display: flex;
  align-items: center;
  gap: 7px;
  position: relative;
}

.participant_avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #fff;
  font-size: 12px;
  font-family: "SF Pro Text Bold";
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  flex-shrink: 0;
}

.participant_line_right {
  position: relative;
}

.participant_line_right .win_money {
  color: #27c12d;
}

.cross {
  position: absolute;
  width: 80vw;
  border: 1px solid #c7c7cc;
  transform: scaleY(0.25);
  right: -10px;
  top: 120%;
  opacity: 0.4;
}

.participant_line_right p {
  color: #808080;
  text-align: right;
}

.participant_number {
  width: 15px;
  text-align: right;
  font-size: 18px;
  color: #808080;
}

.participant_name {
  font-size: 17px;
  color: var(--black-to-white);
}
</style>
